import clsx from "clsx";

interface IImageComponent {
  image?: string;
  cover?: boolean;
}
function ImageComponent({ image, cover = true }: IImageComponent) {
  if (image) {
    return (
      <img
        src={image}
        className={clsx(
          " object-center h-full w-full",
          cover ? "object-cover" : "object-contain"
        )}
        alt=""
      />
    );
  }

  return (
    <img
      src={`${import.meta.env.BASE_URL}images/fallback.jpg`}
      className={clsx(
        " object-center h-full w-full",
        cover ? "object-cover" : "object-contain"
      )}
      alt=""
    />
  );
}

export default ImageComponent;
